import React, { Component } from 'react';
import _ from 'underscore';
import { Search, Tab } from '../../ui';
import { fetch, urls, filterRequestData, filterResponseData, webIM } from '../../utils';
import SessionList from './base';
import SearchList from './search';
import UserList from '../../user/list';
import GroupList from '../../group/list';

export default class extends Component {
    state = {
        tabId: "session",
        actionType: "session",
        session: null,
        tabData: [{
            id: "session",
            clz: "icon-chatting",
            active: true
        }, {
            id: "user",
            clz: "icon-avatar"
        }, {
            id: "group",
            clz: "icon-group"
        }]
    };

    findSession(idOrJidOrObj) {
        const { sessionData } = this.props;

        let obj = {};

        if (_.isNumber(idOrJidOrObj)) {
            obj.id = idOrJidOrObj;
        } else if (_.isString(idOrJidOrObj)) {
            obj.jid = idOrJidOrObj;
        } else {
            obj = idOrJidOrObj;
        }

        if (obj) {
            return _.find(sessionData, obj);
        }
        return null;
    }

    addOrEditSession(res) {
        const { sessionActions, groupActions } = this.props;

        let session = filterResponseData(res);
        let is_group = session.session_type === 'group';
        let group;

        if (is_group) {
            _.extend(session, _.pick(session.group, 'jid', 'name'));
            group = _.pick(session, 'id', 'name', 'jid', 'users');
        }

        sessionActions.addOrEdit(session);

        if (is_group) {
            groupActions.addOrEdit(group);
            webIM.setupGroups([session]);
        }

        return session;
    }

    removeSession(session) {
        const { sessionData, sessionActions, msgActions } = this.props;

        let index;
        let activeSession;

        if (session.is_active) {
            index = _.findIndex(sessionData, { id: session.id });
            activeSession = sessionData[index + 1];
            !activeSession && (activeSession = sessionData[index - 1]);
            this.activeSession(activeSession);
        }
        msgActions.removeBySessionId(session.id);
        sessionActions.remove(session.id);

        return activeSession;
    }

    async closeSession(session) {
        const { onClickSession } = this.props;

        let res = await fetch(urls.api.session.close, {
            method: "post",
            data: _.pick(session, "id")
        });

        if (res.ok) {
            let activeSession = this.removeSession(session);
            if (session.is_active) {
                onClickSession && onClickSession(activeSession);
            }
        } else {
            window.alert(res.message);
        }
    }

    async activeSession(session) {
        if (!session) return;

        const { sessionActions } = this.props;
        let res = { ok: true };

        if (!session.is_active) {
            res = await fetch(urls.api.session.active, {
                method: "post",
                data: _.pick(session, 'id', 'msg_num')
            });
        }

        session.unread_count = 0;
        this.state.session = session;
        sessionActions.active(session);

        return res.ok;
    }

    clickSession(session) {
        this.onItemClick(session, 'session');
    }

    async createSessionByUser({ user }) {
        const loginUser = this.props.user;

        let session = this.findSession(user.jid);
        let res = { ok: true };

        if (!session) {
            res = await fetch(urls.api.session.save, {
                method: 'post',
                data: {
                    session_type: 'user',
                    add_users: [loginUser.jid, user.jid]
                }
            });

            if (res.ok) {
                this.addOrEditSession(res);
                return this.findSession(res.id);
            } else {
                window.alert(res.message);
            }
        }
        return session;
    }

    async createSessionByGroup({ group, add_users }) {
        const loginUser = this.props.user;

        let session = this.findSession(group.jid);
        let res = { ok: true };

        add_users = add_users || [loginUser.jid];

        if (!session) {
            res = await fetch(urls.api.session.save, {
                method: 'post',
                data: filterRequestData({
                    session_type: 'group',
                    group: !_.isEmpty(group) ? group : null,
                    add_users: _.map(add_users, (item) => {
                        return item.jid || item;
                    })
                })
            });

            if (res.ok) {
                this.addOrEditSession(res);
                return this.findSession(res.id);
            } else {
                window.alert(res.message);
            }
        }
        return session;
    }

    onTabClick(id, { execActive }) {
        execActive();
        this.setState({ tabId: id, actionType: id });
        this.refs.list.scrollTop = 0;
    }

    onEnter(ev) {
        let keyword = ev.target.value.trim();
        let { actionType, tabId } = this.state;
        if (actionType === "search") {
            !keyword && this.setState({ actionType: tabId });
            return;
        }

        actionType = keyword ? "search" : this.state.tabId;
        this.setState({ actionType, keyword });
    }

    onInput(ev) {
        let keyword = ev.target.value.trim();
        let actionType = !keyword ? this.state.tabId : "search";
        this.setState({ actionType, keyword });
    }

    onClear() {
        let actionType = this.state.tabId;
        this.setState({ actionType });
    }

    async onItemClick(item, type) {
        const { onClickSession } = this.props;

        if (type === "session") {
            await this.activeSession(item);
            onClickSession && onClickSession(item);
        }
    }

    async onItemDoubleClick(item, type) {
        let session;
        let refs = this.refs;
        let actionType = "session";

        if (type === "group") {
            session = await this.createSessionByGroup({ group: item });
        } else {
            session = await this.createSessionByUser({ user: item });
        }

        if (session) {
            this.setState({ actionType });
            refs.tab && refs.tab.onClick(actionType);
            refs.search.clearText();
            refs.list.scrollTop = 0;
            this.onItemClick(session, 'session');
        }
    }

    render() {
        const { sessionData, userData, groupData } = this.props;
        const { userActions, groupActions } = this.props;
        const placeholder = "搜索：同事、讨论组名称";
        let { actionType, keyword, tabData } = this.state;
        let tabEl;
        let listElment;
        let listElmentProps = { onItemClick: this.onItemClick.bind(this), onItemDoubleClick: this.onItemDoubleClick.bind(this) };

        switch (actionType) {
            case "user":
                listElment = <UserList data={userData} actions={userActions} {...listElmentProps}/>
                break;
            case "group":
                listElment = <GroupList data={groupData} userData={userData} actions={groupActions} {...listElmentProps}/>
                break;
            case "search":
                listElment = <SearchList keyword={keyword} sessionData={sessionData} userData={userData} groupData={groupData} {...listElmentProps}/>
                break;
            default:
                listElment = <SessionList data={sessionData} userData={userData} onItemClose={this.closeSession.bind(this)} {...listElmentProps}/>
                break;
        }

        if (actionType !== "search") {
            tabEl = <Tab ref="tab"
                         itemClassName="btn icon" 
                         data={tabData} 
                         onClick={this.onTabClick.bind(this)} />;
        }

        return (
            <div className="flex flex-v">
              <Search ref="search"
                      maxLength={25}
                      placeholder={placeholder} 
                      onInput={this.onInput.bind(this)} 
                      onClear={this.onClear.bind(this)} 
                      onEnter={this.onEnter.bind(this)} /> 
              { tabEl }
              <div ref="list" className={"list scroll-y list-" + actionType}>
                { listElment }
              </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/session/list/index.js